$(document).ready(function() {

  function togglePlans() {
    var typeSelect = $('.js-dc-pricing-select');
    var typeParent = $('.js-dc-pricing-split');
    var leftClass = 'dc-pricing-split--left';
    var focusClass = 'dc-pricing-split--focus';
    var rightClass = 'dc-pricing-split--right';
    var businessClass = 'dc-pricing-split--business';

    if (typeSelect) {
      typeSelect.on('change', function () {

        var planValue = this.value;
        var planVariant;

        typeParent.removeClass(function (index, className) {
          return (className.match(/(^|\s)dc-pricing-split-\S+/g) || []).join(' ');
        });

        function removeBusinessClass() {
          if (typeParent.hasClass(businessClass)) {
            typeParent.removeClass(businessClass);
          }
        }

        // Assign the variant based on the small screen plan select
        if (planValue === 'left' || planValue === 'focus' || planValue === 'right') {
          planVariant = 'individual';
        }

        if (planValue === 'business-left' || planValue === 'business-focus' || planValue === 'business-right') {
          planVariant = 'business';
        }

        switch (planValue) {
          case 'left':
            typeParent.addClass(leftClass);
            removeBusinessClass();
            updateQueryStringParam('variant', planVariant);
            break;

          case 'focus':
            typeParent.addClass(focusClass);
            removeBusinessClass();
            updateQueryStringParam('variant', planVariant);
            break;

          case 'right':
            typeParent.addClass(rightClass);
            removeBusinessClass();
            updateQueryStringParam('variant', planVariant);
            break;

          case 'business-left':
            typeParent.addClass(leftClass + ' ' + businessClass);
            updateQueryStringParam('variant', planVariant);
            break;

          case 'business-focus':
            typeParent.addClass(focusClass + ' ' + businessClass);
            updateQueryStringParam('variant', planVariant);
            break;

          case 'business-right':
            typeParent.addClass(rightClass + ' ' + businessClass);
            updateQueryStringParam('variant', planVariant);
            break;
        }

      });
    }
  }

  function saveVariantLocalStorage(value) {
    localStorage.setItem('feature-plan-variant', value);
  }

  function togglePlanTypes() {
    var typeSelect = $('.js-dc-toggle-plan-types input');

    if (typeSelect) {
      typeSelect.on("click", function (event) {
        var checked = $(this).attr("value");
        showPlans(checked);
        updateQueryStringParam('variant', checked);
        updateLinkQueryStringParam('.logo-block a', 'variant', checked);
        updateLinkQueryStringParam("a:contains('Pricing')", 'variant', checked);
      });
    }
  }

  function toggleCurrencies() {
    var $currencySelect = $('.js-dc-currency-select')
    if ( $currencySelect.length > 0 ) {
      $currencySelect.on('change', function (event) {
        var $select = $(event.currentTarget);
        var currencyCode = $select.val();
        var $newCurrencySymbol = $('.js-dc-currency[data-code="' + currencyCode + '"]');
        if ( $newCurrencySymbol.length > 0 ) {
          Cookies.set('dc_pricing_currency', currencyCode);
          $('.js-dc-currency').addClass('dc-is-hidden');
          $newCurrencySymbol.removeClass('dc-is-hidden');
          $currencySelect.val(currencyCode);
          $('.js-dc-currency-select--mobile').prop("selectedIndex", 0);
        }
        if (['inr', 'jpy'].indexOf(currencyCode) >= 0) {
          // Number is too large
          $('.js-dc-pricing').addClass('dc-pricing--long');
        } else {
          $('.js-dc-pricing').removeClass('dc-pricing--long');
        }
      });
      var cookieCurrency = Cookies.get('dc_pricing_currency');
      if ( cookieCurrency ) {
        $currencySelect.val(cookieCurrency);
        $currencySelect.first().trigger('change');
      }
    }
  }

  function toggleYearlyPayment() {
    var yearlyCheckbox = $(".js-dc-pay-yearly-checkbox");

    yearlyCheckbox.change(function() {
      $yearly = $('.js-dc-pay-yearly');
      $monthly = $('.js-dc-pay-monthly');
      if ($yearly.length > 0 && $monthly.length > 0) {
        if(this.checked) {
          $monthly.hide();
          $yearly.show();
          yearlyCheckbox.prop("checked", true);
        } else {
          $yearly.hide();
          $monthly.show().style('display', 'flex');
          yearlyCheckbox.prop("checked", false);
        }
      }
    });

    $(".js-dc-savings-sentence").click(function(){
      yearlyCheckbox.prop('checked', true);
      $yearly = $('.js-dc-pay-yearly');
      $monthly = $('.js-dc-pay-monthly');
      if ($yearly.length > 0 && $monthly.length > 0) {
        $monthly.hide();
        $yearly.show().style('display', 'flex');
      }
    });
  }

  // This should be moved if the carousel is used elsewhere
  function hoverCarousel() {
    var triggerElements = '.js-click-carousel-trigger';
    var targetElements = '.js-click-carousel-target';
    var targetSelect = '.js-click-carousel-select';
    var activeClass = 'dc-is-active'

    $(triggerElements).on('mouseenter', function() {
      var targetNumber = $(this).data('click-target');

      $(triggerElements).removeClass(activeClass);
      $(targetElements).removeClass(activeClass);
      $(targetSelect).val(targetNumber);
      $('[data-click-target="' + targetNumber + '"]').addClass(activeClass);
    });

    $(targetSelect).on('change', function () {
      var targetNumber = $(this).val();

      $(triggerElements).removeClass(activeClass);
      $(targetElements).removeClass(activeClass);
      $('[data-click-target="' + targetNumber + '"]').addClass(activeClass);
    });
  }

  function showPlans(type) {
    var typeParent = $('.js-dc-pricing-split');
    var businessClass = 'dc-pricing-split--business';

    saveVariantLocalStorage(type);

    if (type == "business") {
      typeParent.addClass(businessClass);
      $('.js-pricing-toggle-business').prop("checked", true);
    } else {
      typeParent.removeClass(businessClass);
      $('.js-pricing-toggle-individual').prop("checked", true);
    }
  }

  $(window).on('popstate', function (event) {
    showPlans(String(document.location.search).substr(document.location.search.lastIndexOf('variant=') + 8));
  });

  $(window).on('resize', function (event) {
    showPlans(String(document.location.search).substr(document.location.search.lastIndexOf('variant=') + 8));
  });

  // Source: https://gist.github.com/excalq/2961415#gistcomment-1707533
  function updateQueryStringParam(key, value) {
    var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
      urlQueryString = document.location.search,
      newParam = key + '=' + value,
      params = '?' + newParam;

    // If the "search" string exists, then build params from it
    if (urlQueryString) {
      keyRegex = new RegExp('([\?&])' + key + '[^&]*');

      // If param exists already, update it
      if (urlQueryString.match(keyRegex) !== null) {
        params = urlQueryString.replace(keyRegex, "$1" + newParam);
      } else { // Otherwise, add it to end of query string
        params = urlQueryString + '&' + newParam;
      }
    }
    window.history.replaceState({}, "", baseUrl + params);
  };

  function updateLinkQueryStringParam(css_finder, key, value) {
    var link = $(css_finder)[0];
    urlQueryString = link.href;
    newParam = key + '=' + value,
      params = '?' + newParam;

    // If the "search" string exists, then build params from it
    if (urlQueryString) {
      keyRegex = new RegExp('([\?&])' + key + '[^&]*');
      queryParamRegex = new RegExp('([\?&])' + '[^&]*');

      // If param exists already, update it
      if (urlQueryString.match(keyRegex) !== null) {
        newUrl = urlQueryString.replace(keyRegex, "$1" + newParam);
      } else { // Otherwise, add it to end of query string
        newUrl = urlQueryString + '?' + newParam;
      }
    }
    link.href = newUrl;
  }

  togglePlans();
  togglePlanTypes();
  toggleCurrencies();
  toggleYearlyPayment();
  hoverCarousel();
  if (String(document.location.search).substr(document.location.search.lastIndexOf('variant=') + 8) !== "") {
    saveVariantLocalStorage(String(document.location.search).substr(document.location.search.lastIndexOf('variant=') + 8));
  }
  showPlans(localStorage.getItem('feature-plan-variant'));
});
